import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import Api from 'utils/api'
import { buildUrl, clamp } from 'utils/helpers'
import config from 'config'

export const fetchPayoutLicensedKeyInfos = createAsyncThunk(
  'payoutSlice/fetchLicensedKeyInfos',
  async ({
    startDate, endDate, page = 0, limit = 10, 
    kind, locality_uuid, company_uuid}, { getState, rejectWithValue, dispatch }) => {
    try {
      const setParams = () => {
        let params = []
        if (page) params.push(`page=${page + 1}`)
        if (limit) params.push(`limit=${limit}`)
        if (startDate) params.push(`start_date=${startDate}`)
        if (endDate) params.push(`end_date=${endDate}`)
        if (kind) params.push(`kind=${kind}`)
        if (locality_uuid) params.push(`locality_uuid=${locality_uuid}`)
        if (company_uuid) params.push(`company_uuid=${company_uuid}`)
        return params.join('&')
      }
      const infos = await Api.request(
        buildUrl(`/payout/licensed_key_infos?${setParams()}`),
        {},
        `${config.redirectUri}/api/v1`
      )
      return infos
    } catch {
      return rejectWithValue()
    }
  }
)

export const fetchPayoutLicensedKey = createAsyncThunk(
  'payoutSlice/fetchLicensedKey',
  async ({startDate, endDate, page = 0, limit = 10, state, company_uuid}, { getState, rejectWithValue, dispatch }) => {
    try {
      const setParams = () => {
        let params = []
        if (page) params.push(`page=${page + 1}`)
        if (limit) params.push(`limit=${limit}`)
        if (startDate) params.push(`start_date=${startDate}`)
        if (endDate) params.push(`end_date=${endDate}`)
        if (state) params.push(`state=${state}`)
        if (company_uuid) params.push(`company_uuid=${company_uuid}`)
        return params.join('&')
      }
      const infos = await Api.request(
        buildUrl(`/payout/licensed_keys?${setParams()}`),
        {},
        `${config.redirectUri}/api/v1`
      )
      return infos
    } catch (error) {
      console.log(error)
      return rejectWithValue(error)
    }
  }
)


// reducers
export const payoutSlice = createSlice({
  name: 'payoutSlice',
  initialState: {
    payout_licensed_keys_info: null,
    payout_licensed_keys: null,
    page: 1,
    limit: 20,
  },
  reducers: {
    incPage: (state) => {
      state.page = clamp(state.page + 1, 1, state.pages)
    },
    decPage: (state) => {
      state.page = clamp(state.page - 1, 1, state.pages)
    },
  },
  extraReducers: {
    [fetchPayoutLicensedKeyInfos.fulfilled]: (state, { payload }) => {
      state.payout_licensed_keys_info = payload
    },
    [fetchPayoutLicensedKey.fulfilled]: (state, { payload }) => {
      state.payout_licensed_keys = payload
    },
  },
})

export const { incPage, decPage } = payoutSlice.actions

export default payoutSlice.reducer
